export type ColumnKey = 'id' | 'subject' | 'requester' | 'assignee' | 'priority' | 'created' | 'labels' | 'project' | 'sla';

export interface ColumnDef {
	key: ColumnKey;
	label: string;
	/**
	 * Fixed column width as a CSS length. The design-system table interpolates this
	 * straight into `width:`, so a bare number would emit invalid CSS and be dropped.
	 * Omitted for the column that should absorb the remaining space (Subject).
	 */
	width?: string;
	/** Whether the user can hide this column from the Columns dropdown. */
	toggleable: boolean;
	/** Initial visibility before the user has interacted with the dropdown. */
	defaultVisible: boolean;
}

// Order = visual order in the table.
export const LG_COLUMNS: readonly ColumnDef[] = [
	{key: 'id', label: 'Id', width: '90px', toggleable: false, defaultVisible: true},
	{key: 'subject', label: 'Subject', toggleable: false, defaultVisible: true},
	{key: 'requester', label: 'Requester', width: '190px', toggleable: true, defaultVisible: true},
	{key: 'assignee', label: 'Assignee', width: '175px', toggleable: true, defaultVisible: true},
	{key: 'priority', label: 'Priority', width: '110px', toggleable: true, defaultVisible: true},
	{key: 'created', label: 'Created', width: '110px', toggleable: true, defaultVisible: true},
	{key: 'labels', label: 'Labels', width: '200px', toggleable: true, defaultVisible: false},
	{key: 'project', label: 'Project', width: '230px', toggleable: false, defaultVisible: true},
	{key: 'sla', label: 'SLA', width: '140px', toggleable: false, defaultVisible: true},
];

export const COLUMN_WIDTHS: Readonly<Record<ColumnKey, string | undefined>> = LG_COLUMNS.reduce(
	(acc, col) => ({...acc, [col.key]: col.width}),
	{} as Record<ColumnKey, string | undefined>
);

export const COLUMN_LABELS: Readonly<Record<ColumnKey, string>> = LG_COLUMNS.reduce(
	(acc, col) => ({...acc, [col.key]: col.label}),
	{} as Record<ColumnKey, string>
);

export const TOGGLEABLE_COLUMNS: readonly ColumnDef[] = LG_COLUMNS.filter(c => c.toggleable);

export const DEFAULT_VISIBLE_COLUMN_KEYS: ReadonlySet<ColumnKey> = new Set(
	LG_COLUMNS.filter(c => c.defaultVisible).map(c => c.key)
);

export const ALWAYS_ON_COLUMN_KEYS: ReadonlySet<ColumnKey> = new Set(LG_COLUMNS.filter(c => !c.toggleable).map(c => c.key));
